module.exports = __webpack_public_path__ + "img/zh.a3818e6d.png";